// extracted by mini-css-extract-plugin
export default {"container":"LayoutNew_container__hymdQ","sub_container":"LayoutNew_sub_container__09zic"};